import { appealsApi } from '../appealsApi';
import { PolicyDocumentView, PolicySearchResult, PolicySearchRequest } from '../types/policyTypes';

const policyEndpoints = appealsApi.injectEndpoints({
  endpoints: (builder) => ({
    // Search for policies
    // POST /policy/search
    searchPolicies: builder.query<PolicySearchResult[], PolicySearchRequest>({
      query: (params) => ({
        url: 'policy/search',
        method: 'POST',
        body: params,
      }),
      providesTags: ['PolicySearch'],
    }),

    // Upload a policy document
    // POST /policy/upload
    uploadPolicyDocument: builder.mutation<PolicyDocumentView, FormData>({
      query: (formData) => ({
        url: 'policy/upload',
        method: 'POST',
        body: formData,
        // Don't set Content-Type for FormData - let browser set it with boundary
        formData: true,
      }),
      invalidatesTags: ['PolicyList'],
    }),

    // List uploaded policy documents
    // GET /policies?payerName=<payerName>&isActive=<isActive>
    listPolicyDocuments: builder.query<
      PolicyDocumentView[],
      { payerName?: string; isActive?: boolean }
    >({
      query: (params) => ({
        url: 'policies',
        params,
      }),
      providesTags: (result) =>
        result
          ? [...result.map(({ id }) => ({ type: 'Policy' as const, id })), 'PolicyList']
          : ['PolicyList'],
    }),

    // Get a single policy document
    // GET /policy?id=<id>
    getPolicyDocument: builder.query<PolicyDocumentView, string>({
      query: (id) => ({
        url: 'policy',
        params: { id },
      }),
      providesTags: (result, error, id) => [{ type: 'Policy', id }],
    }),
  }),
  overrideExisting: false,
});

export const {
  useSearchPoliciesQuery,
  useLazySearchPoliciesQuery,
  useUploadPolicyDocumentMutation,
  useListPolicyDocumentsQuery,
  useGetPolicyDocumentQuery,
} = policyEndpoints;
